import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { OverPaidAgingIncomingInvoiceTodoFormProps } from "models/propTypes/incomingInvoicePropTypes";
import { IncomingInvoiceFormTypes } from "models/formTypes";
import { FileUploaderProps, RadioGroupProps, TextInputProps } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { AgingIncomingInvoiceOverPaidActions } from "models/enums/incomingInvoice";
//#endregion
//#region components
import {
  FileUploader,
  RadioGroup,
  TextInput,
  useWintForm,
  VerticalFormField,
  WintForm,
} from "components/common/wintForms";
import { Grid } from "@mui/material";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const OverPaidAgingIncomingInvoiceTodoForm: ForwardRefRenderFunction<
  FormHandles,
  OverPaidAgingIncomingInvoiceTodoFormProps
> = (props, ref) => {
  const { wintFormProps, connect, values } = useWintForm<IncomingInvoiceFormTypes.OverPaidAgingInvoiceTodo>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    handleSubmit: props.handleSubmit,
    enableReinitialize: true,
  });

  const overPaidChoices = EnumHelper.getNumericItemValues(AgingIncomingInvoiceOverPaidActions).map((key) => ({
    id: key,
    value: LocalizationHelperInstance.getTranslatedEnumValue("IncomingInvoice.AgingOverPaidTodoAction", key),
  }));

  return (
    <WintForm {...wintFormProps}>
      <Grid container className={cssExports.sectionedForm} marginBottom={-2.5}>
        <VerticalFormField<RadioGroupProps> Component={RadioGroup} {...connect("action")} items={overPaidChoices} />
        {values.action === AgingIncomingInvoiceOverPaidActions.OverpaidInfoSupplied && (
          <>
            <VerticalFormField<TextInputProps>
              Component={TextInput}
              {...connect("explanation")}
              label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Explanation)}
              noOuterSpacing
            />
            <VerticalFormField<FileUploaderProps> Component={FileUploader} {...connect("files")} />
          </>
        )}
      </Grid>
    </WintForm>
  );
};

export default forwardRef(OverPaidAgingIncomingInvoiceTodoForm);
